import { z } from 'zod';
import { recaptchaTokenSchema } from './shared.js';
/** Employer inquiry — the homepage CTA form and `/contact` (replaces businessInquiry + contactForm). */
export const inquirySchema = z.object({
    name: z.string().trim().min(1).max(255),
    company: z.string().trim().min(1).max(255),
    email: z.string().trim().email(),
    phone: z.string().trim().max(40).optional().or(z.literal('')),
    /** Canonical service key (`services` doc id) or `unsure`. */
    service: z.string().trim().max(80).optional().or(z.literal('')),
    message: z.string().trim().max(2048).optional().or(z.literal('')),
    source: z.enum(['home', 'contact']).default('contact'),
    recaptchaToken: recaptchaTokenSchema,
});
//# sourceMappingURL=inquiry.js.map